import React, { createContext, useContext, useState } from "react";
import {
  getPaymentsProgressApprovalsByApprover,
} from "../api/paymentsProgressApi";

const PendingPaymentsProgressApprovalsContext = createContext();

const isPendingStatus = (status) => {
  const s = String(status || "").toLowerCase();
  return !s || s === "in_processing" || s === "pending" || s === "на рассмотрении";
};

export function PendingPaymentsProgressApprovalsProvider({ children }) {
  const [pendingPaymentsProgressApprovalsCount, setPendingPaymentsProgressApprovalsCount] =
    useState(0);

  const updatePendingPaymentsProgressApprovalsCount = async (userData) => {
    if (!userData?.id) {
      setPendingPaymentsProgressApprovalsCount(0);
      return;
    }

    try {
      const approvals = await getPaymentsProgressApprovalsByApprover();
      const pendingCount = (Array.isArray(approvals) ? approvals : []).filter(
        (approval) => {
          const myApprover = approval?.approvers?.find(
            (approver) =>
              Number(approver?.user?.id) === Number(userData.id) ||
              Number(approver?.user_id) === Number(userData.id)
          );
          return myApprover && isPendingStatus(myApprover.status);
        }
      ).length;

      setPendingPaymentsProgressApprovalsCount(pendingCount);
    } catch (error) {
      console.debug("Нет согласований выплат ЭП в ожидании");
      setPendingPaymentsProgressApprovalsCount(0);
    }
  };

  return (
    <PendingPaymentsProgressApprovalsContext.Provider
      value={{
        pendingPaymentsProgressApprovalsCount,
        updatePendingPaymentsProgressApprovalsCount,
      }}
    >
      {children}
    </PendingPaymentsProgressApprovalsContext.Provider>
  );
}

export const usePendingPaymentsProgressApprovals = () =>
  useContext(PendingPaymentsProgressApprovalsContext);
